import React, { Fragment } from 'react';

import http from 'api/http';
import {boatAPI, trailerAPI} from 'api/requests';

import { downloadFile } from 'helpers';

import Select, {selectType} from 'Components/Select';
import {METRICS} from 'constants/metrics';
import {ROLES} from 'constants/roles';
import Text from 'Components/Text';
import MonthPicker from 'Components/MonthPicker';
import Button from 'Components/Button';

export default class MetricsScene extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedMetric: '',
      metricResult: undefined,
      modelYear: '',
      calendarMonth: '',
      currentYear: '',
      calendarYear: '',
      yearsList: [],
      requestInProcess: false,
      dateError: '',
      downloadRequestInProcess: false,
    };
  }

  componentDidMount() {
    this.roleSwitch();

    this.getCurrentYear().then(currentYear => {
      let yearsList = [];
      for (let i = -1; i < 20; i++) {
        yearsList.push(currentYear - i);
      }
      this.setState({ currentYear: currentYear, yearsList });
    });
  }

  roleSwitch = () => {
    const { user, match } = this.props;

    let URLRole = '';

    Object.keys(ROLES).forEach(roleKey => {
      if (match.params.manufacturerRole === ROLES[roleKey].nameForUrl) URLRole = ROLES[roleKey];
    });

    if (URLRole && user.getActiveRole() !== URLRole.serverName) {
      user.changeMenu(URLRole.serverName);
    }
  };

  getMetricResult = () => {
    const { selectedMetric, modelYear, calendarYear, calendarMonth, dateError } = this.state;

    if (!dateError && selectedMetric.requestPath) {
      this.setState({ requestInProcess: true, metricResult: undefined }, () => {
        http.get(selectedMetric.requestPath(modelYear, calendarYear, calendarMonth)).then(({ data: metricResult }) => {
          this.setState({ metricResult, requestInProcess: false });
        });
      });
    }
  };

  getCurrentYear = () => {
    const { user } = this.props;

    return new Promise((resolve, reject) => {
      switch (user.getActiveRole()) {
        case ROLES.BOAT_MANUFACTURER.serverName:
          http.get(boatAPI.currentModelYear).then(({ data }) => resolve(data[1] || data[0]));
          break;
        case ROLES.COMPONENT_MANUFACTURER.serverName:
          http.get(boatAPI.currentModelYear).then(({ data }) => resolve(data[1] || data[0]));
          break;
        case ROLES.TRAILER_MANUFACTURER.serverName:
          http.get(trailerAPI.currentModelYear).then(({ data }) => resolve(data));
          break;
        default:
          resolve(new Date().getFullYear());
      }
    });
  };

  selectModelYear = modelYear => {
    const { selectedMetric, currentYear } = this.state;

    this.setState(
      { modelYear: modelYear || currentYear, calendarMonth: 0, dateError: '', metricResult: undefined },
      () => {
        if (!selectedMetric.withMonth) {
          this.getMetricResult();
        }
      }
    );
  };

  selectPreviousMonth = () => {
    let currentMonth = new Date().getMonth();
    let currentYear = +new Date().getFullYear();

    currentMonth = currentMonth.toString().length === 1 ? '0' + currentMonth : currentMonth;

    if (!currentMonth) {
      currentYear = currentYear - 1;
      currentMonth = 12;
    }

    this.setState({ calendarYear: currentYear, calendarMonth: currentMonth, metricResult: undefined }, () => {
      this.getMetricResult();
    });
  };

  selectCalendarYear = calendarYear => {
    let dateError = '';

    if (calendarYear > +new Date().getFullYear()) {
      dateError = 'Please select a month in the past';
    }

    this.setState({ calendarYear, dateError, calendarMonth: 0 });
  };

  selectMonth = calendarMonth => {
    const currentMonth = new Date().getMonth();
    const currentYear = +new Date().getFullYear();
    let dateError = '';

    if (calendarMonth && this.state.calendarYear >= currentYear && +calendarMonth > +currentMonth) {
      dateError = 'Please select a month in the past';
    }

    if (calendarMonth.toString().length === 1) calendarMonth = '0' + calendarMonth;

    this.setState({ calendarMonth: calendarMonth, dateError, metricResult: undefined }, () => {
      this.getMetricResult();
    });
  };

  selectMetricType = metricInfo => {
    this.setState({ selectedMetric: metricInfo, modelYear: '', calendarMonth: '', metricResult: undefined }, () => {
      this.selectModelYear();
      if (metricInfo.withMonth) this.selectPreviousMonth();
    });
  };

  downloadReport = () => {
    const { user: { accountCode } } = this.props;

    const { selectedMetric, modelYear } = this.state;

    if (selectedMetric.downloadPath) {
      this.setState({downloadRequestInProcess: true});

      const fileName = selectedMetric.downloadFileName
        ? selectedMetric.downloadFileName(accountCode, modelYear)
        : `Metric_Report_${accountCode}.xlsx`;

      http.get(selectedMetric.downloadPath(modelYear), {responseType: 'blob'})
        .then(({data}) => {
          downloadFile(data, fileName);
        })
        .finally(() => {
          this.setState({downloadRequestInProcess: false});
        })
    }
  };

  render() {
    const { user } = this.props;
    const {
      selectedMetric,
      modelYear,
      calendarMonth,
      yearsList,
      metricResult,
      requestInProcess,
      calendarYear,
      dateError,
      downloadRequestInProcess,
    } = this.state;

    return (
      <section className='scene__scene-wrapper'>
        <section className='scene__content-wrapper'>
          <section className='scene__scene-header'>
            <header>Metrics</header>
          </section>
          <section className='scene_section'>
            <header>Type</header>
            <Select
              selectionList={METRICS[user.getActiveRole()]}
              defaultItem={selectedMetric}
              type={selectType.primary}
              dropDownClassName='_top_51'
              withoutSearch
              placeholder='Please select metric type'
              itemNameIndicator='name'
              handleSelect={this.selectMetricType}
            />
          </section>
          {selectedMetric && (selectedMetric.withYear || selectedMetric.withMonth) && (
            <section className='scene_section'>
              <header>Time period</header>
              {selectedMetric.withYear && (
                <Select
                  selectionList={yearsList}
                  defaultItem={typeof modelYear === 'number' ? modelYear.toString() : modelYear}
                  type={selectType.primary}
                  mainWrapperClassName='_margin_right_30'
                  label='Model year *'
                  handleSelect={this.selectModelYear}
                />
              )}
              {selectedMetric.withMonth && (
                <MonthPicker
                  mainWrapperClassName='_margin_top_18'
                  label='Calendar month and year *'
                  handleSelectYear={this.selectCalendarYear}
                  handleSelectMonth={this.selectMonth}
                  chosenYear={calendarYear ? Number(calendarYear) : undefined}
                  chosenMonth={calendarMonth}
                  error={dateError}
                />
              )}
            </section>
          )}
          {selectedMetric && (
            <section className='scene_section'>
              {selectedMetric.downloadPath ? (
                <Button
                  label="Download"
                  buttonClassName='_height_40 _width_120'
                  onClick={this.downloadReport}
                  disabledWithSpinner={downloadRequestInProcess}
                />
              ) : (
                <Fragment>
                  <header>Result</header>
                  {requestInProcess ? (
                    <div className='_flex _ai_center _jc_center _width_pc_100 _height_pc_100'>
                      <div className='__spinner _width_90 _height_90' />
                    </div>
                  ) : metricResult !== undefined ? (
                    <Text
                      mainWrapperClassName='text__wrapper_primary _width_pc_100'
                      textClassName='text__text_primary'
                      label={selectedMetric.resultText}
                      value={metricResult}
                    />
                  ) : (
                    <div></div>
                  )}
                </Fragment>
              )}
            </section>
          )}
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Metrics/index.jsx